import { render, staticRenderFns } from "./notification-success.vue?vue&type=template&id=0f089fc2&scoped=true"
import script from "./notification-success.vue?vue&type=script&lang=js"
export * from "./notification-success.vue?vue&type=script&lang=js"
import style0 from "./notification-success.vue?vue&type=style&index=0&id=0f089fc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f089fc2",
  null
  
)

export default component.exports